import { Component } from '@angular/core';

@Component({
  selector: 'app-electricalstability-vertical-header',
  standalone: false,
  templateUrl: './electricalstability-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class ElectricalstabilityVerticalHeaderComponent {

  
}
